import { render } from "./ServerReportResults.vue?vue&type=template&id=4fc749bb"
import script from "./ServerReportResults.vue?vue&type=script&lang=js"
export * from "./ServerReportResults.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Reports/Agent/ServerReportResults.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4fc749bb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4fc749bb', __exports__)) {
    api.reload('4fc749bb', __exports__)
  }
  
  module.hot.accept("./ServerReportResults.vue?vue&type=template&id=4fc749bb", () => {
    api.rerender('4fc749bb', render)
  })

}


export default __exports__